import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import type {
  ReportDashboardComponent,
  ReportDashboardMetricOptions,
  VisualizationDataTypeUnion,
} from '@core/reports-types';
import type { SortValue } from '@core/search-types';
import { ResizeObserverEntryDirective } from '@core/user-interface-legacy';

import { VisualizationLayoutComponent } from '../visualization-layout/visualization-layout.component';
import { VisualizationLoadingIndicatorComponent } from '../visualization-loading-indicator/visualization-loading-indicator.component';
import { VisualizationRendererComponent } from '../visualization-renderer/visualization-renderer.component';
import { ReportsVisualizationTitleComponent } from '../visualization-title/visualization-title.component';

@Component({
  imports: [
    VisualizationLayoutComponent,
    ReportsVisualizationTitleComponent,
    VisualizationLoadingIndicatorComponent,
    VisualizationRendererComponent,
    ResizeObserverEntryDirective,
  ],
  selector: 'reports-builder-visualization',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
  templateUrl: './reports-builder-visualization.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsBuilderVisualizationComponent {
  public component = input.required<ReportDashboardComponent | null>();
  public metric = input.required<ReportDashboardMetricOptions | null>();
  public visualization = input.required<VisualizationDataTypeUnion | null>();

  public currColWidth = input<number>();

  public loading = input.required<boolean>();
  public loaded = input.required<boolean>();
  public failed = input.required<boolean>();

  public refresh = output<void>();
  public tableSortChange = output<SortValue>();
}
